import React from "react";

import { Typography } from "@material-ui/core";

//css
import ModalHeaderCss from "./styles";
const useStyles = ModalHeaderCss();

export default (props) => {
    const classes = useStyles();
    return (
        <div className={classes.header}>
            <Typography variant="h6" component="h3" className={classes.title}>
                {props.state.tipo} {props.props.route.title}
            </Typography>
        </div>
    );
};
